import { ProfileContainer } from "../../containers";
import './style.scss'

function Policy() {
    return (
        <div id="profile">
            <ProfileContainer />
        </div>
    );
}
export default Policy;